"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));
var _DialogIllustratedFaceIDConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-concur_android.css") : void 0);
var _DialogIllustratedFaceIDConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-concur_default.css") : void 0);
var _DialogIllustratedFaceIDConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-concur_gateway.css") : void 0);
var _DialogIllustratedFaceIDConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-concur_ios.css") : void 0);
var _DialogIllustratedFaceIDSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_fiori_3_dark.css") : void 0);
var _DialogIllustratedFaceIDSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_fiori_3_hcb.css") : void 0);
var _DialogIllustratedFaceIDSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_fiori_3_hcw.css") : void 0);
var _DialogIllustratedFaceIDSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_fiori_3.css") : void 0);
var _DialogIllustratedFaceIDSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_horizon_dark.css") : void 0);
var _DialogIllustratedFaceIDSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_horizon_hcb.css") : void 0);
var _DialogIllustratedFaceIDSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_horizon_hcw.css") : void 0);
var _DialogIllustratedFaceIDSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./DialogIllustratedFaceID-sap_horizon.css") : void 0);
var _excluded = ["classNameMap", "className", "title"];
var styles = {
  concur_android: _DialogIllustratedFaceIDConcur_android.default,
  concur_default: _DialogIllustratedFaceIDConcur_default.default,
  concur_gateway: _DialogIllustratedFaceIDConcur_gateway.default,
  concur_ios: _DialogIllustratedFaceIDConcur_ios.default,
  sap_fiori_3_dark: _DialogIllustratedFaceIDSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _DialogIllustratedFaceIDSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _DialogIllustratedFaceIDSap_fiori_3_hcw.default,
  sap_fiori_3: _DialogIllustratedFaceIDSap_fiori_.default,
  sap_horizon_dark: _DialogIllustratedFaceIDSap_horizon_dark.default,
  sap_horizon_hcb: _DialogIllustratedFaceIDSap_horizon_hcb.default,
  sap_horizon_hcw: _DialogIllustratedFaceIDSap_horizon_hcw.default,
  sap_horizon: _DialogIllustratedFaceIDSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-dialog-illustrated-faceid';
var DialogIllustratedFaceID = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classNameMap = props.classNameMap,
    className = props.className,
    title = props.title,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var idSuffix = (0, _useUniqueId.default)();
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "sapIllus-DialogIllustratedFaceID_".concat(idSuffix),
    role: "img"
  }, otherProps, {
    className: classnames(CSS_BLOCK, className),
    ref: ref
  }), title && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "79.9998",
    cy: "84.6316",
    r: "77.0916",
    className: classnames("".concat(CSS_BLOCK, "__path2"))
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "sapIllus-DialogIllustratedFaceID_".concat(idSuffix, "_mask"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "2",
    y: "-11",
    width: "156",
    height: "173"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M157.091 84.6316C157.091 127.208 122.576 161.723 79.9998 161.723C37.4233 161.723 2.9082 127.208 2.9082 84.6316C2.9082 42.0551 36.1023 -10.1895 78.6788 -10.1895C121.255 -10.1895 157.091 42.0551 157.091 84.6316Z",
    className: classnames("".concat(CSS_BLOCK, "__path2"))
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#sapIllus-DialogIllustratedFaceID_".concat(idSuffix, "_mask)")
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0985 107.57C19.0985 107.57 19.0985 107.57 19.0985 107.57C19.0985 169.469 46.7052 219.649 80.7597 219.649C114.814 219.649 142.421 169.469 142.421 107.57C142.421 107.57 142.421 107.57 142.421 107.57H19.0985Z",
    className: classnames("".concat(CSS_BLOCK, "__path1"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.021 218.775C105.022 214.897 130.341 166.643 130.518 107.57H142.421V107.57C142.421 169.469 114.814 219.649 80.7599 219.649C78.1389 219.649 75.556 219.352 73.021 218.775Z",
    className: classnames("".concat(CSS_BLOCK, "__path3"))
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "80.7603",
    cy: "107.569",
    rx: "61.6612",
    ry: "12.0753",
    className: classnames("".concat(CSS_BLOCK, "__path4"))
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "8.73676",
    cy: "10.799",
    rx: "8.73676",
    ry: "10.799",
    transform: "matrix(-0.877901 -0.478843 -0.478843 0.877901 43.123 51.186)",
    className: classnames("".concat(CSS_BLOCK, "__path3"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0988 88.286L19.0986 88.286C19.0986 54.9572 46.7053 27.939 80.7598 27.939C114.805 27.939 142.406 54.9423 142.421 88.2583C142.421 88.2675 142.421 88.2768 142.421 88.286C142.421 94.955 114.815 100.361 80.76 100.361C46.7054 100.361 19.0988 94.955 19.0988 88.286Z",
    className: classnames("".concat(CSS_BLOCK, "__path1"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.112 80.4239C120.112 80.4812 120.112 80.5384 120.112 80.5957H120.102C119.636 84.7724 102.201 88.1301 80.7606 88.1301C59.3207 88.1301 41.8854 84.7724 41.4188 80.5957H41.4099C41.4097 80.5489 41.4095 80.502 41.4095 80.4552C41.4093 80.4447 41.4092 80.4343 41.4092 80.4238C41.4092 80.4133 41.4093 80.4029 41.4095 80.3924C41.4269 59.1369 59.0385 41.9111 80.7609 41.9111C102.494 41.9111 120.112 59.1539 120.112 80.4239Z",
    className: classnames("".concat(CSS_BLOCK, "__path4"))
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "52.2817",
    y: "5.58594",
    width: "5.40729",
    height: "36.325",
    rx: "2.70364",
    className: classnames("".concat(CSS_BLOCK, "__path4"))
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "103.831",
    y: "2.61841",
    width: "5.40729",
    height: "39.2926",
    rx: "2.70364",
    className: classnames("".concat(CSS_BLOCK, "__path4"))
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "54.9852",
    cy: "10.5197",
    r: "7.90127",
    className: classnames("".concat(CSS_BLOCK, "__path1"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8928 16.2603C56.2566 16.2603 59.7941 12.7227 59.7941 8.35899C59.7941 6.36153 59.0529 4.53719 57.8305 3.146C60.7885 4.28804 62.8868 7.15877 62.8868 10.5196C62.8868 14.8833 59.3493 18.4209 54.9856 18.4209C52.6193 18.4209 50.4959 17.3807 49.0479 15.7326C49.9306 16.0734 50.8899 16.2603 51.8928 16.2603Z",
    className: classnames("".concat(CSS_BLOCK, "__path3"))
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "106.535",
    cy: "10.5197",
    r: "7.90127",
    className: classnames("".concat(CSS_BLOCK, "__path5"))
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "66.7901",
    cy: "65.0206",
    r: "5.50496",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "94.7296",
    cy: "65.0206",
    r: "5.50496",
    className: classnames("".concat(CSS_BLOCK, "__path6"))
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "75.1181",
    y1: "79.7262",
    x2: "86.4018",
    y2: "79.7262",
    className: classnames("".concat(CSS_BLOCK, "__path14")),
    strokeWidth: "2.25763",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "sapIllus-DialogIllustratedFaceID_".concat(idSuffix, "_mask2"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "63",
    y: "0",
    width: "88",
    height: "104"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "63.4521",
    y: "0.799805",
    width: "87.2589",
    height: "102.363",
    className: classnames("".concat(CSS_BLOCK, "__path13"))
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#sapIllus-DialogIllustratedFaceID_".concat(idSuffix, "_mask2)")
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "130.634",
    cy: "56.483",
    rx: "8.73676",
    ry: "10.799",
    transform: "rotate(-28.6099 130.634 56.483)",
    className: classnames("".concat(CSS_BLOCK, "__path8"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0988 88.286L19.0986 88.286C19.0986 54.9572 46.7053 27.939 80.7598 27.939C114.805 27.939 142.406 54.9423 142.421 88.2583C142.421 88.2675 142.421 88.2768 142.421 88.286C142.421 94.955 114.815 100.361 80.76 100.361C46.7054 100.361 19.0988 94.955 19.0988 88.286Z",
    className: classnames("".concat(CSS_BLOCK, "__path8"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.055 95.5412C130.488 92.6645 130.712 89.7217 130.712 86.7278C130.712 57.9302 109.971 33.8588 82.2671 27.9565C115.616 28.7396 142.406 55.4353 142.421 88.2582L142.421 88.2859C142.421 91.0088 137.819 93.5213 130.055 95.5412Z",
    className: classnames("".concat(CSS_BLOCK, "__path9"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.112 80.4239C120.112 80.4812 120.112 80.5384 120.112 80.5957H120.102C119.636 84.7724 102.201 88.1301 80.7606 88.1301C59.3207 88.1301 41.8854 84.7724 41.4188 80.5957H41.4099C41.4097 80.5489 41.4095 80.502 41.4095 80.4552C41.4093 80.4447 41.4092 80.4343 41.4092 80.4238C41.4092 80.4133 41.4093 80.4029 41.4095 80.3924C41.4269 59.1369 59.0385 41.9111 80.7609 41.9111C102.494 41.9111 120.112 59.1539 120.112 80.4239Z",
    className: classnames("".concat(CSS_BLOCK, "__path10"))
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "103.831",
    y: "5.58594",
    width: "5.40729",
    height: "36.325",
    rx: "2.70364",
    className: classnames("".concat(CSS_BLOCK, "__path11"))
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "106.535",
    cy: "10.5197",
    r: "7.90127",
    className: classnames("".concat(CSS_BLOCK, "__path8"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.93 16.5362C107.294 16.5362 110.832 12.9987 110.832 8.63496C110.832 6.32887 109.844 4.25353 108.268 2.80908C111.798 3.59914 114.436 6.75132 114.436 10.5197C114.436 14.8834 110.899 18.4209 106.535 18.4209C104.477 18.4209 102.603 17.6344 101.197 16.3455C101.755 16.4704 102.335 16.5362 102.93 16.5362Z",
    className: classnames("".concat(CSS_BLOCK, "__path9"))
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "66.7901",
    cy: "65.0206",
    r: "5.50496",
    className: classnames("".concat(CSS_BLOCK, "__path6"))
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "94.7296",
    cy: "65.0206",
    r: "5.50496",
    className: classnames("".concat(CSS_BLOCK, "__path6"))
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.2456 78.3423V78.3423C78.6682 80.2734 82.8516 80.2734 86.2743 78.3423V78.3423",
    className: classnames("".concat(CSS_BLOCK, "__path14")),
    strokeWidth: "2.51272",
    strokeLinecap: "round"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: "59.3105",
    y: "106.93",
    width: "86.3342",
    height: "4.55101",
    rx: "2.27551",
    transform: "rotate(-90 59.3105 106.93)",
    className: classnames("".concat(CSS_BLOCK, "__path12"))
  })));
});
DialogIllustratedFaceID.displayName = 'DialogIllustratedFaceID';
DialogIllustratedFaceID.propTypes = {
  title: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(DialogIllustratedFaceID);
exports.default = _default;